export default __webpack_public_path__ + "../staticImages/logo.png";